module.exports = __webpack_public_path__ + "img/horizontal_3_3_3009.a53ec966.png";